import { c as _c } from "react/compiler-runtime";
export default function MakersPlaceIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <img src="/Makersplace-icon.jpg" alt="Makersplace" className="tw-ring-1 tw-ring-white/20 tw-rounded-full tw-object-contain tw-flex-shrink-0 tw-h-5 tw-w-5 tw-align-top" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}